"use strict";

var map = {

    googleMap: null,
    markerClusterer: null,
    data: [],
    selectedLocationId: -1,

    markerIconURL: "",
    clusterIconPath: "",

    divisionFilters: [],
    locationTypeFilters: [],
    regionFilters: [],

    mapMarkers: [],

    dataForCounters: [],

    clusteredData: {},

    deferLoad: false,

    zoomLevelForLabels: 100,

    zoomToFit: false,

    clusteredMarkers: [],

    drawTriggers: {
        base: "base.draw",
        zoomChanged: "zoom_changed",
        positionChanged: "position_changed",
        clusteringEnd: "clustering_end"
    },

    loadCallback: function () {

        if (this.data.length == 0) {
            this.deferLoad = true;
            return;
        }

        /// source: http://jsfiddle.net/6t3pyr94/
        google.maps.Marker.prototype.setLabel = function (label) {
            this.label = new MarkerLabel({
                map: this.map,
                marker: this,
                text: label,
                geoId: this.get("details").geoId
            });
            this.label.bindTo('position', this, 'position');
        };

        google.maps.Marker.prototype.removeLabel = function () {
            this.label.setMap(null);
            this.label = null;
        };

        google.maps.Marker.prototype.redrawLabel = function (reason) {
            var label = this.label;
            try {
                label.draw.call(label,reason);
            }
            catch (e) { }
        };

        google.maps.Marker.prototype.getLabelElement = function () {
            return this.label.getLabelElement();
        };

        var MarkerLabel = function (options) {
            this.setValues(options);
            this.htmlElement = document.createElement('div');
            this.htmlElement.className = 'map-marker-label';
            this.htmlElement.style.visibility = "hidden";
            var self = this;
            $(this.htmlElement).on("click", function () {
                google.maps.event.trigger(self.marker, "click");
            });
        };

        MarkerLabel.prototype = $.extend(new google.maps.OverlayView(), {
            onAdd: function () {
                this.getPanes().overlayImage.appendChild(this.htmlElement);
                var selfLabel = this;
                this.listeners = [
                    google.maps.event.addListener(this, 'position_changed', function () {
                        selfLabel.draw(map.drawTriggers.positionChanged);
                    })
                ];
            },
            draw: function (reason) {
                if (typeof reason === "undefined") {
                    reason = map.drawTriggers.base;
                }
                var shouldShow = this.map.getZoom() >= map.zoomLevelForLabels && !$(".location-details").length;
                var shouldDraw = (this.map.getZoom() >= (map.zoomLevelForLabels - 1)) && !$(".location-details").length;
                shouldDraw = shouldDraw && this.map.getBounds().contains(this.get('position'));
                var isClustered = false;
                if (shouldDraw) {
                    isClustered = map.isMarkerInCluster(this.get('marker'));
                }
                shouldDraw = shouldDraw && !isClustered;
                shouldShow = shouldShow && shouldDraw;
                if (shouldDraw) {
                    var text = String(this.get('text'));
                    var position = this.getProjection().fromLatLngToDivPixel(this.get('position'));
                    this.htmlElement.innerHTML = text;
                    var $el = $(this.htmlElement);
                    var left = (position.x + 20);
                    var top = (position.y - (($el.height() / 2) + 25));
                    this.htmlElement.style.left = left + 'px';
                    this.htmlElement.style.top = top + 'px';
                }
                if (shouldShow) {
                    this.htmlElement.style.visibility = "visible";
                } else {
                    this.htmlElement.style.visibility = "hidden";
                }
            },
            getLabelElement: function () {
                return this.htmlElement;
            }
        });
        ///

        var mapElement = $("#map");

        var mapStyles = [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }];

        this.googleMap = new google.maps.Map(mapElement.get(0), {
            zoom: 2,
            center: {
                lat: 0, lng: 0
            },
            streetViewControl: false,
            styles: mapStyles,
            mapTypeControl: false,
            fullscreenControl: false
        });

        var self = this;

        /*
        google.maps.event.addListener(this.googleMap, "zoom_changed", function () {
            self.mapMarkers.forEach(function (marker) {
                marker.redrawLabel(map.drawTriggers.zoomChanged);
            });
        });
        */

        for (var i = 0; i < this.data.length; i++) {
            var markerData = this.data[i];
            var geoId = markerData.geoId;
            if (!this.clusteredData[geoId]) {
                this.clusteredData[geoId] = [markerData];
            } else {
                markerData.showSpacer = true;
                this.clusteredData[geoId].push(markerData);                
            }
        }

        this.dataForCounters = this.data;

        var selectedLocationId = this.selectedLocationId;               

        if (this.divisionFilters.length > 0) {
            this.applyFilters();
        } else if (selectedLocationId > 0) {
            this.mapMarkers.push(this.addMarkerWithDetails(this.getDataWithId(selectedLocationId)));
            this.zoomToFitVisibleMarkers();
            this.showLocationDetails(selectedLocationId);
            this.applyFilters(true);
        }
        else {
            this.applyFilters();
        } 
    },
    /*
    readjustMarkerLabels: function () {
        var shouldReadjust = (this.googleMap.getZoom() >= map.zoomLevelForLabels) && !$(".location-details").length;
        if (!shouldReadjust) {
            return;
        }
        var self = this;
        var visibleMarkers = self.getVisibleMarkers();
        var labels = visibleMarkers.map(function (m) { return m.getLabelElement(); });
        var bounds = labels.map(function (l, idx) {
            var $label = $(l);
            var offset = $label.offset();
            return {
                idx: idx,
                l: offset.left,
                t: offset.top,
                r: offset.left + $label.outerWidth(),
                b: offset.top + $label.outerHeight()
            };
        });
        /// source: https://stackoverflow.com/a/2752387
        var intersects = function (b1, b2) {
            return !(
                b2.l > b1.r ||
                b2.r < b1.l ||
                b2.t > b1.b ||
                b2.b < b1.t
            );
        };
        var clash = [];
        bounds.forEach(function (boundsObj) {
            var clashing = bounds.filter(function (b) {
                return boundsObj.idx != b.idx && intersects(boundsObj, b);
            }).map(function (b) {
                return b.idx;
            });
            if (clashing.length == 0) {
                return;
            }
            clashing.push(boundsObj.idx);
            clash.push(clashing);
        });
        var handled = [];
        clash.forEach(function (c) {
            var alreadyHandled = false;
            c.forEach(function (i) {
                if (handled.indexOf(i) < 0) {
                    handled.push(i);
                } else {
                    alreadyHandled = true;
                }
            });
            if (alreadyHandled) {
                return;
            }
            var adjustedLabels = labels.filter(function (l, idx) { return c.indexOf(idx) >= 0; });
            if (adjustedLabels.length == 1) {
                return;
            } else if (adjustedLabels.length == 2) {
                var $second = $(adjustedLabels[1]);
                var left = parseInt($second.css('left'), 10);
                left -= ($second.outerWidth() + 40);
                $second.css({ 'left': left + 'px' });
            } else if (adjustedLabels.length == 3) {

            }
        });
    },*/

    isMarkerInCluster: function (marker) {

        return this.clusteredMarkers.indexOf(marker.get("id")) >= 0;

    },

    getVisibleMarkers: function () {
        var result = [];

        for (var i = this.mapMarkers.length, bounds = this.googleMap.getBounds(); i--;) {
            if (bounds.contains(this.mapMarkers[i].getPosition())) {
                result.push(this.mapMarkers[i]);
            }
        }

        return result;
    },


    getDataWithGeoId: function (geoId) {
        return this.data.filter(function (d) { return d.geoId == geoId; });
    },

    getDataWithId: function (id) {
        return this.data.find(function (d) { return d.id == id; });
    },

    getMarkerIcon: function (text, fillColor, textColor, outlineColor) {
        if (!!this.markerIconURL) {
            return this.markerIconURL;
        }
        if (!text) text = '•'; //generic map dot
        var iconUrl = "https://chart.googleapis.com/chart?cht=d&chdp=mapsapi&chl=pin%27i\\%27[" + text + "%27-2%27f\\hv%27a\\]h\\]o\\" + fillColor + "%27fC\\" + textColor + "%27tC\\" + outlineColor + "%27eC\\Lauto%27f\\&ext=.png";
        return iconUrl;
    },

    setUpMarkerClusterer: function () {
        var styles = [
            { url: this.clusterIconPath, height: 53, width: 53, anchor: [0,0], textColor: '#7AEA97', fontWeight: 'normal', textSize: 28 }
        ];
        if (!!this.markerClusterer) {
            this.markerClusterer.clearMarkers();
            google.maps.event.clearInstanceListeners(this.markerClusterer);
        }
        this.markerClusterer = new MarkerClusterer(this.googleMap, this.mapMarkers, {
            styles: styles
        });
        var self = this;
        google.maps.event.addListener(this.markerClusterer, 'clusteringend', function (clusterer) {

            var clustered = [];

            var clusters = clusterer.getClusters() || [];
            for (var i = 0; i < clusters.length; i++) {
                var markers = clusters[i].getMarkers() || [];
                if (markers.length > 1) {
                    clustered.push.apply(clustered, markers.map(function (m) { return m.get("id"); }));
                }
            }

            self.clusteredMarkers = clustered;

            self.mapMarkers.forEach(function (marker) {
                marker.redrawLabel(map.drawTriggers.clusteringEnd);
            });
        });
    },

    addMarkerWithDetails: function (details) {

        var data = this.getDataWithGeoId(details.geoId);
        var label = "";
        for (var i = data.length; i--;) {
            var d = data[i];
            label += '<span class="map-marker-label-name">' + d.name + '</span>' + (i > 0 ? '<div class="map-marker-label-spacer">&nbsp;</div>' : '');
        }

        var marker = new google.maps.Marker({
            position: { lat: details.lat, lng: details.lng },
            map: this.googleMap,
            icon: this.getMarkerIcon(null, "000", "fff", "000")
        });
        this.setMarkerId(marker, details.id);
        this.setMarkerDetails(marker, details);
        marker.setLabel(label);

        var self = this;

        marker.addListener("click", function () {
            self.filterMarkers([details.id]);
            self.zoomToFitVisibleMarkers();
            self.showLocationDetails(details.id);
        });
        return marker;
    },

    setMarkerDetails: function (marker, details) {
        marker.set("details", details);
    },

    setMarkerId: function (marker, id) {
        marker.set("id", id);
    },

    getMarkerId: function (marker) {
        return marker.get("id");
    },

    getMarkerDetails: function (marker) {
        return marker.get("details");
    },

    resetView: function () {
        var self = this;

        this.clusteredMarkers = [];

        this.dataForCounters = this.data;

        this.mapMarkers.forEach(function (marker) {
            marker.setMap(null);
        });

        this.mapMarkers = this.data.map(function (d) {
            return self.addMarkerWithDetails(d);
        });

        this.removeDuplicateMarkers();
        this.setUpMarkerClusterer();

        if (this.zoomToFit) {
            this.zoomToFitVisibleMarkers();
        } else {
           this.googleMap.setCenter({ lat: 0, lng: 0 });
           this.googleMap.setZoom(2);
        }

        this.updateCounters();

    },

    removeDuplicateMarkers: function () {
        var geoIds = [];
        var result = [];
        var self = this;
        this.mapMarkers.forEach(function (m) {
            var data = self.getMarkerDetails(m);
            var geoId = data.geoId;
            var matchingGeoId = geoIds.find(function (g) {
                return g == geoId;
            });
            if (typeof matchingGeoId === "undefined") {
                geoIds.push(geoId);
                result.push(m);
            } else {
                m.removeLabel();
                m.setMap(null);
            }
        });
        this.mapMarkers = result;
    },

    findMarkerWithId: function (id) {
        var self = this;
        return this.mapMarkers.find(function (m) { return self.getMarkerId(m) == id; });
    },

    zoomToFitVisibleMarkers: function () {

        if (this.mapMarkers.length == 0) {
            return;
        }

        var getMarkerLat = function (marker) { return marker.getPosition().lat(); };
        var getMarkerLng = function (marker) { return marker.getPosition().lng(); };

        if (this.mapMarkers.length == 1) {
            var marker = this.mapMarkers[0];
            this.googleMap.setCenter({ lat: getMarkerLat(marker), lng: getMarkerLng(marker) });
            this.googleMap.setZoom(14);
        } else {
            var east = Math.max.apply(null, this.mapMarkers.map(getMarkerLng));
            var west = Math.min.apply(null, this.mapMarkers.map(getMarkerLng));
            var north = Math.max.apply(null, this.mapMarkers.map(getMarkerLat));
            var south = Math.min.apply(null, this.mapMarkers.map(getMarkerLat));

            this.googleMap.fitBounds({ east: east, west: west, north: north, south: south });
        }

    },

    showLocationDetails: function (id) {        
        var marker = this.findMarkerWithId(id);
        var details = this.getMarkerDetails(marker);
        var geoId = details.geoId;
        var sites = this.getDataWithGeoId(geoId);
        var locations = { locations: sites };
        var detailsTemplate = $("#location-details-template").html();
        var detailsElement = Mustache.render(detailsTemplate, locations);
        $("#map").append(detailsElement);
        if (sites.length > 1) {
            $("#map").find(".location-details").addClass("location-scroll");
        }
        marker.redrawLabel("show location details");
        contact.selectSite.call(contact, id);
    },

    closeLocationDetails: function (element) {
        $(element).remove();
        this.selectedLocationId = -1;
        this.applyFilters();
    },

    handleFilterChange: function () {
        var selectedDivisions = [];
        var selectedTypes = [];
        var selectedRegions = [];

        var processCheckedValues = function (selector, targetArray) {
            $(selector).each(function (idx, el) {
                var input = $(el);
                if (!!input.prop("checked")) {
                    targetArray.push(parseInt(input.val()));
                }
            });
        };

        processCheckedValues("input[name=map-division]", selectedDivisions);
        processCheckedValues("input[name=map-locationType]", selectedTypes);
        processCheckedValues("input[name=map-region]", selectedRegions);

        this.divisionFilters = selectedDivisions;
        this.locationTypeFilters = selectedTypes;
        this.regionFilters = selectedRegions;
        this.applyFilters();
    },

    applyFilters: function (doNotResetView) {
        var self = this;

        var divisionComparator = function (location, division) {
            return location.divisions.indexOf(division) >= 0;
        };
        var typeComparator = function (location, type) {
            return location.type == type;
        };
        var regionComparator = function (location, region) {
            return location.region == region;
        };


        var filterByDivisions = function (source, divisions) {
            if (divisions.length == 0) {
                return source;
            }
            return source.filter(function (location) {
                return divisions.filter(function (div) {
                    return location.divisions.indexOf(div) >= 0;
                }).length > 0;
            });
        };
        var filterByTypes = function (source, types) {
            if (types.length == 0) {
                return source;
            }
            return source.filter(function (location) {
                return types.indexOf(location.type) >= 0;
            });
        };
        var filterByRegions = function (source, regions) {
            if (regions.length == 0) {
                return source;
            }
            return source.filter(function (location) {
                return regions.indexOf(location.region) >= 0;
            });
        };

        var filteredData = [];

        var filteredByDivisions = filterByDivisions(this.data, this.divisionFilters);
        var filteredByTypes = filterByTypes(this.data, this.locationTypeFilters);
        var filteredByRegions = filterByRegions(this.data, this.regionFilters);

        filteredData = filteredByDivisions.slice();
        filteredData = filterByTypes(filteredData, this.locationTypeFilters);

        this.dataForCounters = filteredData.slice();

        filteredData = filterByRegions(filteredData, this.regionFilters);

        this.updateCheckboxes("input[name=map-division]", filterByRegions(filteredByTypes, this.regionFilters), divisionComparator);
        this.updateCheckboxes("input[name=map-locationType]", filterByRegions(filteredByDivisions, this.regionFilters), typeComparator);
        this.updateCheckboxes("input[name=map-region]", filterByDivisions(filteredByTypes, this.divisionFilters), regionComparator);

        if (this.divisionFilters.length == 0 && this.locationTypeFilters.length == 0 && this.regionFilters.length == 0) {
            if (!doNotResetView) {
                this.resetView();
            }
            return;
        }

        this.filterMarkers(filteredData.map(function (d) { return d.id; }));
        this.zoomToFitVisibleMarkers();
        this.updateCounters();
    },

    updateCheckboxes: function (selector, dataSource, comparator) {
        $(selector).each(function (idx, el) {
            var input = $(el);
            var value = parseInt(input.val());
            var count = dataSource.filter(function (d) {
                return comparator(d, value);
            }).length;
            input.prop("disabled", count == 0);
        });
    },
 
    filterMarkers: function (ids) {

        if (!ids) {
            return;
        }

        var self = this;

        var idsToAdd = ids.slice();

        // remove markers that don't match
        this.mapMarkers.forEach(function (m) {
            var markerId = self.getMarkerId(m);
            if (ids.indexOf(markerId) < 0) {
                m.setMap(null);
            } else {
                // the marker is already on the map - no need to add it, so let's remove of from the list of new markers
                var idx = idsToAdd.indexOf(markerId);
                if (idx >= 0) {
                    idsToAdd.splice(idx, 1);
                }
            }
        });

        // if we're already showing some matching markers, keep them in the markers array, but remove others
        this.mapMarkers = this.mapMarkers.filter(function (m) {
            return ids.indexOf(self.getMarkerId(m)) >= 0;
        });

        idsToAdd.forEach(function (id) {
            self.mapMarkers.push(self.addMarkerWithDetails(self.getDataWithId(id)));
        });

        this.removeDuplicateMarkers();
        this.setUpMarkerClusterer();

    },

    updateCounters: function () {
        var self = this;
        $("input[name=map-region]").each(function (idx, el) {
            var input = $(el);
            var region = parseInt(input.val());
            var count = self.dataForCounters.filter(function (d) {
                return d.region == region;
            }).length;
            input.siblings().find("span.count").text("(" + count + ")");
        });
    }

};

map.location = function (data) {
    this.id = data.id || 0;
    this.url = data.url || "";
    this.name = data.name || "";
    this.address = data.address || "";
    this.email = data.email || "";
    this.phone = data.phone || "";
    this.lat = data.lat || 0.0;
    this.lng = data.lng || 0.0;
    this.geoId = data.geoId || "";
    this.externalLink = data.externalLink || null;
    this.externalLinkText = data.externalLinkText || null;
    this.divisions = data.divisions || [];
    this.showInvoiceInformationLink = data.showInvoiceInformationLink || false;
    this.showSpacer = false;
    if (data.hasOwnProperty("type")) {
        this.type = data.type;
    } else {
        this.type = -1;
    }
    if (data.hasOwnProperty("region")) {
        this.region = data.region;
    } else {
        this.region = -1;
    }
};

document.addEventListener("DOMContentLoaded", function () {
    $("input[name=map-division]").on("change", function () {
        map.handleFilterChange("division");
    });
    $("input[name=map-locationType]").on("change", function () {
        map.handleFilterChange("locationType");
    });
    $("input[name=map-region]").on("change", function () {
        map.handleFilterChange("region");
    });
    var updateToggleControl = function (showExpandOrCollapse) {
        if (showExpandOrCollapse) {
			$(".map-filters-toggle").removeClass("open");
	        $(".map-filters-toggle").addClass("closed");
		} else {
	        $(".map-filters-toggle").addClass("open");
	        $(".map-filters-toggle").removeClass("closed");
        }
    }
    $(".map-filters-toggle").on("click", function () {
        var filtersContainer = $(".map-filters");
        var isVisible = filtersContainer.is(":visible");
        updateToggleControl(isVisible);
        filtersContainer.slideToggle("fast", function () {
            isVisible = $(this).is(":visible");
            updateToggleControl(!isVisible);
        });
    });
});